import { render } from "./CVView.vue?vue&type=template&id=58e9902c&scoped=true"
const script = {}

import "./CVView.vue?vue&type=style&index=0&id=58e9902c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58e9902c"]])

export default __exports__